(function () {
  console.log('[CUSTOM CRISP] Script chargé');

  function lockCrispInput() {
    const crisp = document.querySelector('.crisp-client');

    if (!crisp) {
      console.log('[CUSTOM CRISP] Chat non trouvé');
      return;
    }

    console.log('[CUSTOM CRISP] Chat trouvé');

    // Désactive la zone de texte
    crisp.querySelectorAll('textarea[name="message"]').forEach((textarea) => {
      textarea.disabled = true;
      textarea.readOnly = true;
      textarea.setAttribute('disabled', 'disabled');
      textarea.setAttribute('readonly', 'readonly');
      textarea.style.pointerEvents = 'none';
      textarea.style.userSelect = 'none';

      console.log('[CUSTOM CRISP] Textarea verrouillée');
    });

    // Désactive le bouton envoyer
    crisp.querySelectorAll('[aria-label="Send"]').forEach((btn) => {
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.35';

      console.log('[CUSTOM CRISP] Bouton envoyer verrouillé');
    });

    // Désactive le bouton fichier
    crisp.querySelectorAll('[aria-label="Send a file"]').forEach((btn) => {
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.35';

      const input = btn.querySelector('input[type="file"]');
      if (input) input.disabled = true;

      console.log('[CUSTOM CRISP] Upload verrouillé');
    });

    // Désactive les emojis
    crisp.querySelectorAll('[aria-label="Insert an emoji"]').forEach((btn) => {
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.35';

      console.log('[CUSTOM CRISP] Emoji verrouillé');
    });
  }

  function initObserver() {
    const observer = new MutationObserver(() => {
      lockCrispInput();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    console.log('[CUSTOM CRISP] MutationObserver lancé');
  }

  // Vérifie toutes les 500ms jusqu'à ce que Crisp soit chargé
  const interval = setInterval(() => {
    if (document.querySelector('.crisp-client')) {
      console.log('[CUSTOM CRISP] Crisp détecté');

      lockCrispInput();
      initObserver();

      clearInterval(interval);
    }
  }, 500);

  // Si l'API Crisp est disponible
  window.$crisp = window.$crisp || [];
  window.$crisp.push([
    'on',
    'chat:opened',
    function () {
      console.log('[CUSTOM CRISP] Chat ouvert');
      setTimeout(lockCrispInput, 200);
    },
  ]);
})();